export const TEXT_COLOR = "text-neutral-900"
